export default "__VITE_ASSET__BFtMtIpy__"